import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58f0444f"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src", "alt", "title"];
import { reactive, computed } from 'vue';
import { fetchBanner } from '@/features/HomeBanner/services';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import BaseLoaderSpinner from '@/components/_atoms/BaseLoaderSpinner.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Banner',
    setup(__props) {
        const state = reactive({
            banner: {
                redirectLink: '',
                urlImage: '',
                title: '',
            },
            hasLink: false,
            loading: false,
            hasError: false,
        });
        const hasRedirectLink = computed(() => state.banner.redirectLink.length);
        const clickBanner = () => {
            useMixpanelConfig('view_home_click_banner_welcome');
            if (hasRedirectLink.value) {
                return window.open(state.banner.redirectLink, '_blank');
            }
        };
        const handleImageLoaded = () => {
            state.loading = false;
        };
        const loadBanner = async () => {
            state.loading = true;
            try {
                const response = await fetchBanner();
                state.banner = response;
                if (hasRedirectLink.value) {
                    state.hasLink = true;
                }
            }
            catch {
                state.loading = false;
                state.hasError = true;
            }
        };
        loadBanner();
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (!state.hasError)
                ? (_openBlock(), _createBlock(_component_base_card_v2, {
                    key: 0,
                    class: "home-banner__card"
                }, {
                    default: _withCtx(() => [
                        (state.banner.urlImage)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: _normalizeClass(`home-banner__image ${state.hasLink ? 'home-banner__with-link' : ''}`),
                                onClick: clickBanner,
                                src: state.banner.urlImage,
                                alt: state.banner.title,
                                title: state.banner.title,
                                onLoad: handleImageLoaded
                            }, null, 42, _hoisted_1))
                            : _createCommentVNode("", true),
                        (state.loading)
                            ? (_openBlock(), _createBlock(BaseLoaderSpinner, {
                                key: 1,
                                class: "home-banner__spinner"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
